// Centralized contact information for Mundalo
// Update these values to change contact info site-wide

export const CONTACT = {
  email: 'hello@mundalo.com',
  phone: {
    us: '+1 214 695 3448',
    mx: '+52 55 5456 7678',
    // WhatsApp uses Mexico number
    whatsapp: '525554567678', // No spaces or special chars for wa.me link
  },
  // Prefilled WhatsApp message
  whatsappMessage: "Hi Mundalo, I'd like to discuss my project / relocation.",
};

// Generate WhatsApp URL with prefilled message
export const getWhatsAppUrl = () => {
  const message = encodeURIComponent(CONTACT.whatsappMessage);
  return `https://wa.me/${CONTACT.phone.whatsapp}?text=${message}`;
};

// Format phone for tel: links
export const getPhoneLink = (type = 'us') => {
  const phone = type === 'mx' ? CONTACT.phone.mx : CONTACT.phone.us;
  return `tel:${phone.replace(/\s/g, '')}`;
};
